import { MAIN_CONTENT_ID } from 'core/layout/constants';

export type FocusTarget = HTMLElement | null | undefined;

const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ');

// Todas las cabeceras de la lección llevan otros controles: su conmutador es AccordionHeaderToggle
const ACCORDION_TOGGLE_SELECTOR = '.accordion-header-toggle';

/** Ids contiguos al que se quita, primero el siguiente y después el anterior. */
export function getAdjacentIds(ids: ReadonlyArray<string> | null | undefined, removedId: string): string[] {
  const index = ids ? ids.indexOf(removedId) : -1;
  if (index === -1) return [];
  return [ids[index + 1], ids[index - 1]].filter((id): id is string => Boolean(id));
}

export function getFirstFocusable(root: Element | null | undefined): HTMLElement | null {
  return root?.querySelector<HTMLElement>(FOCUSABLE_SELECTOR) ?? null;
}

export function getAccordionToggle(accordionId: string | null | undefined): HTMLElement | null {
  const accordion = accordionId ? document.getElementById(accordionId) : null;
  return accordion?.querySelector<HTMLElement>(ACCORDION_TOGGLE_SELECTOR) ?? null;
}

export function getMainContent(): HTMLElement | null {
  return document.getElementById(MAIN_CONTENT_ID);
}

/** Enfoca el primer candidato que de verdad recibe el foco: `focus()` no avisa si el elemento está oculto o desactivado. */
export function focusFirstAvailable(candidates: ReadonlyArray<FocusTarget>): boolean {
  for (const candidate of candidates) {
    candidate?.focus();
    if (candidate && document.activeElement === candidate) return true;
  }
  return false;
}
